import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faSpinner,
  faClock,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import { useDailyJoke } from '../../../hooks/useHome';
import css from '../HomePage.module.css';

interface Props {
  onClose: () => void;
}

export default function DailyJokeModal({ onClose }: Props) {
  const { data: joke, isLoading, isError } = useDailyJoke(true);

  function handleOverlayClick(e: React.MouseEvent) {
    if (e.target === e.currentTarget) onClose();
  }

  return (
    <div className={css.modalOverlay} onClick={handleOverlayClick}>
      <div className={css.modal}>
        <div className={css.modalHeader}>
          <span />
          <h4 className={css.modalTitle} style={{ color: 'var(--primary-600)' }}>
            Daily Joke
          </h4>
          <button className={css.modalClose} onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className={css.modalBody} style={{ minHeight: 200 }}>
          {isLoading && (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <FontAwesomeIcon
                icon={faSpinner}
                spin
                size="2x"
                style={{ color: 'var(--primary-500)' }}
              />
              <p style={{ marginTop: '0.5rem', color: 'var(--gray-600)' }}>
                Loading your daily dose of humor...
              </p>
            </div>
          )}

          {isError && (
            <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--error-600)' }}>
              <FontAwesomeIcon icon={faExclamationTriangle} size="2x" />
              <p style={{ marginTop: '0.5rem' }}>
                Sorry, couldn&apos;t fetch today&apos;s joke. Please try again later!
              </p>
            </div>
          )}

          {joke && (
            <>
              <div className={css.jokeText}>
                <p>{joke.joke}</p>
              </div>
              <div className={css.jokeMeta}>
                <FontAwesomeIcon icon={faClock} /> Fetched:{' '}
                {joke.fetchedAtUK ?? joke.lastUpdatedUK ?? 'Unknown time'}
              </div>
            </>
          )}
        </div>

        <div className={css.modalFooter} style={{ justifyContent: 'center' }}>
          <button className={`${css.btnSm} ${css.btnOutline}`} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
